import React, { Component } from 'react';
import config from '../../../views/config/App_data';
import { browserHistory } from 'react-router';

export class OrderLinkInvalid extends Component {
  render() {
    return (
      <div className='row justify-content-center'>
        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
          <div className='card-group mb-0'>
            <div className='card p-2  '>
              <div className='card-block text-center'>
                <h4>
                  <span style={{ color: 'red' }}>
                    The link has <span style={{ color: 'red' }}>expired</span>.
                  </span>
                </h4>
                {/* <p>*You will also receive confirmation of your purchase via email</p> */}
              </div>
              <div className='row'>
                <div className='col-xs-12 col-sm-12 col-md-12 pr-3 pl-3 text-center'>
                  <b>To access your order details. Please login and follow the steps.</b>
                  <p>{`Navigate to Profile > Order History`} </p>
                </div>

                <div className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10 m-0 d-flex justify-content-center'>
                  <button
                    className='btn btn-primary pointer_class'
                    onClick={() =>
                      browserHistory.push({ pathname: config.REACT_APP_FRONTEND_ENDPOINT })
                    }
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderLinkInvalid;



// WEBPACK FOOTER //
// ./src/views/Pages/CheckoutVerify/OrderLinkInvalid.js